// @core/api/endpoints/subscription/get_subscription_analytics.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetSubscriptionAnalyticsResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get subscription analytics
 * Returns subscription metrics including MRR, churn rate, LTV, and plan distribution. Supports time-based filtering and granularity selection.
 */
export async function GetSubscriptionAnalytics(
  params?: {
    granularity?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
    tenant_id?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetSubscriptionAnalyticsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics`;
  const requestOptions = options;
  return client.get<GetSubscriptionAnalyticsResponse>(requestPath, { ...requestOptions, params });
}
